import {Typography} from "@mui/material";
import {useEffect, useState} from "react";

const SwitchLanguageButton = () => {
  const [currentLang, setCurrentLang] = useState<string>('ru');

  useEffect(() => {
    // Получаем текущий язык из localStorage при загрузке
    const storedLang = localStorage.getItem('yt-widget');
    if (storedLang) {
      const parsedLang = JSON.parse(storedLang)?.lang;
      setCurrentLang(parsedLang || 'ru');
    } else {
      setCurrentLang('ru'); // Значение по умолчанию
    }
  }, []);

  const toggleLanguage = () => {
    const newLang = currentLang === 'ru' ? 'en' : 'ru';

    // Вызываем функцию из предоставленного кода для смены языка
    localStorage.setItem(
      'yt-widget',
      JSON.stringify({
        lang: newLang,
        active: true,
      })
    );

    setCurrentLang(newLang);

    // Перезагружаем страницу, чтобы применить изменения
    window.location.reload();
  };
  return (
    <>
      <div id="ytWidget" style={{display: 'none'}}></div>
      <Typography
        variant="h7"
        sx={{opacity: 0.5, cursor: 'pointer'}}
        onClick={toggleLanguage}
      >
        {currentLang === 'ru' ? 'En' : 'Ru'}
      </Typography>
    </>
  )
}

export default SwitchLanguageButton;
